import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Externe bezorgingen',
  fields: {
    pickup: 'Ophalen',
    dropoff: 'Aflevering',
    status: 'Status',
    estimated_time: 'Geschatte tijd',
    actual_time: 'Werkelijke tijd',
    actions: 'Acties',
    time: 'Tijd',
    pickup_estimate: 'Schatting ophaling',
    dropoff_estimate: 'Schatting aflevering',
  },
  labels: {
    pickup: 'Ophalen',
    dropoff: 'Aflevering',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Wacht op chauffeur',
    [DeliveryStatus.RunnerAssigned]: 'Chauffeur toegewezen',
    [DeliveryStatus.OnRoutePickup]: 'Onderweg naar ophaling',
    [DeliveryStatus.ArrivedPickup]: 'Aangekomen bij ophaling',
    [DeliveryStatus.PickedUp]: 'Opgehaald',
    [DeliveryStatus.OnRouteDropoff]: 'Onderweg naar aflevering',
    [DeliveryStatus.ArrivedDropoff]: 'Aangekomen bij aflevering',
    [DeliveryStatus.Completed]: 'Voltooid',
    [DeliveryStatus.Cancelled]: 'Geannuleerd',
  },
  buttons: {
    actions: 'Acties',
    open_tracking_url: 'Bezorging volgen',
    show_order_details: 'Besteldetails tonen',
    call_restaurant: 'Restaurant bellen',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
  },
};
